'use strict';
import React, { Component } from 'react';
import { hashHistory } from 'react-router';

class TableRowCheckBox extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isChecked: false,
            clickCheckbox: props.clickCheckbox,
            routeToEditarProducto: props.routeToEditarProducto
        };
        this.clickCheckbox = this.clickCheckbox.bind(this);
        this.routeToEditarProducto = this.routeToEditarProducto.bind(this);
    }

    clickCheckbox() {
        this.state.clickCheckbox(this.props.ID);
    }

    routeToEditarProducto() {
        this.state.routeToEditarProducto(this.props.ID);
    }

    render() {
        return (
            <div>
                {!this.props.isCurrentUser &&
                    <div key={"checkProdItem" + this.props.ID} className="row">
                        <div key={"checkProdItemCol" + this.props.ID} className="col-xs-12">
                            <ul className="no-bullets no-padding no-margin">
                                <li className="inlineListItem2">
                                    <label id={"producto" + this.props.ID} onClick={this.routeToEditarProducto}>{this.props.nombre} </label>
                                </li>
                            </ul>
                        </div>
                    </div>
                }
            </div>
        );
    }
}

export default TableRowCheckBox